import { News } from 'src/components/news';

export const NewsPage = () => <News />;
